// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"BongoFontAwesomeIcon_iconWrapper__36e_w","icon":"BongoFontAwesomeIcon_icon__2wbV_"};